import * as SellActions from './actions';

const initialState = {
  doingSellDeal: false
}

const sellReducer = (state = initialState, action) => {
  switch (action.type) {
    case SellActions.COMMITTED_SELL_DEAL: {
      return {
        ...state,
        doingSellDeal: action.doingSellDeal
      }
    }
    default: {
      return state;
    }
  }
}

export default sellReducer;
